import React, { FC } from "react";
import "./container.scss";
import Chat from "@app/pippa/components/chat";

const Container: FC = () => {
  return (
    <div className="widget-container" data-testid="pippa-widget-container">
      <Chat />
    </div>
  );
};

export default Container;
